module.exports = __webpack_public_path__ + "img/marvel-gpt.753a7e68.png";